export function callsList(payload) {
  return { items: Array.isArray(payload?.items) ? payload.items : [], total: Number.isFinite(payload?.total) ? payload.total : 0 };
}

export function callsOptions(payload) {
  return {
    clients: Array.isArray(payload?.clients) ? payload.clients : [],
    managers: Array.isArray(payload?.managers) ? payload.managers : [],
    canDial: payload?.canDial === true,
    providerEnabled: payload?.providerEnabled === true,
    unavailableReason: typeof payload?.unavailableReason === 'string' ? payload.unavailableReason : '',
    currentUserId: payload?.currentUserId || '',
  };
}
